/**
 * Enumeration for the OptiDrive KPIs.
 *
 * @readonly
 * @enum {string}
 */
export const OptiDriveKpis = {
    SPEEDING: 'SPEEDING',
    DRIVING: 'DRIVING',
    IDLING: 'IDLING',
    FUEL: 'FUEL',
    ENERGY_CONSUMPTION: 'ENERGY_CONSUMPTION',
    GREEN_SPEED: 'GREEN_SPEED',
    CONSTANT_SPEED: 'CONSTANT_SPEED',
    COASTING: 'COASTING',
    HIGH_REVVING: 'HIGH_REVVING',
    CRUISE_CONTROL: 'CRUISE_CONTROL',
    VIDEO: 'VIDEO'
}

Object.freeze(OptiDriveKpis)
